import React, { useEffect, useRef, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, TextField,
  DialogActions, Button, Typography, Box
} from "@mui/material";
import AuthService from "../../api/axiosInstance";
import endpoints from "../../api/endpoints";
import { trackRegisterCompleted, trackRegisterStarted } from "../../analytics/ga";

export default function RegisterDialog({ open, onClose }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const hasTrackedRegisterStart = useRef(false);

  useEffect(() => {
    if (open) {
      hasTrackedRegisterStart.current = false;
    }
  }, [open]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (!hasTrackedRegisterStart.current) {
      trackRegisterStarted();
      hasTrackedRegisterStart.current = true;
    }
    try {
      await AuthService.post(endpoints.USERS, form);
      setError(null);
      setSuccess("Account created. Please check your email to verify your account before logging in.");
      trackRegisterCompleted();
    } catch {
      setSuccess(null);
      setError("Registration failed.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      BackdropProps={{ sx: { backgroundColor: "rgba(0,0,0,0.25)" } }}
      PaperProps={{
        sx: {
          backgroundColor: "#fff",
          "&:hover": { backgroundColor: "#fff" },
        },
      }}
    >
      <DialogTitle>Create Your Account</DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {error && <Typography color="error">{error}</Typography>}
          {success && <Typography color="success.main">{success}</Typography>}
          <TextField name="email" label="Email" fullWidth onChange={handleChange} />
          <TextField name="password" label="Password" type="password" fullWidth onChange={handleChange} />
        </Box>
      </DialogContent>
      <DialogActions>
        {success ? (
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        ) : (
          <>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit}>
              Create Account
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
